import React from 'react'
import { Button, Switch, FormControlLabel } from '@material-ui/core'
import styled from 'styled-components'
import List from '../../components/List'
import DashboardPage from '../../layouts/DashboardPage'
import ConfirmDialog from '../../components/ConfirmDialog'

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 160px;
  & p {
    display: none;
  }
  padding-right: 16px;
`

const columns = [
  { id: 'createdAt', disablePadding: true, label: 'Created' },
  { id: 'status', disablePadding: true, label: 'Published', kind: 'status' },
  { id: 'publicStatus', disablePadding: true, label: 'Public', kind: 'status' },
  { id: 'name', disablePadding: true, label: 'Name' },
  { id: 'description', disablePadding: true, label: 'Description' },
  { id: 'channelsCount', disablePadding: true, label: 'Channels' },
]

const PublicOnlySwitch = ({ publicOnly, onChange }) => {
  return (
    <SelectWrapper>
      <FormControlLabel
        label='Public Only'
        control={
          <Switch
            checked={publicOnly}
            onChange={({ target: { checked } }) => onChange(checked)}
          />
        }
      />
    </SelectWrapper>
  )
}

export default class Ecosystems extends React.Component {
  state = { open: false }

  onOpen = () => this.setState({ open: true })

  onSave = async (details) => {
    return await this.props.onCreate(details)
  }

  onCancel = () => {
    this.setState({ open: false })
  }

  // update-ecosystems-request

  render() {
    console.log(this.props.items)

    return (
      <DashboardPage
        forceDefaultActions
        kind='list'
        title='Ecosystems'
        addLabel='Create Ecosystem'
        addLink='/ecosystems/create'
        actions={() => {
          return (
            <ConfirmDialog
              progress
              title={'Update All Ecosystems'}
              action={this.props.onUpdateEcosystems}
              confirmationButtonPrimary
              confirmButtonLabel={'Update'}
              confirmButtonProps={{
                variant: 'contained',
                color: 'primary',
              }}
              confirmationText={
                'Are you sure you want to update all ecosystems? It will take some time. Please, don’t run multiple updates simultaneously.'
              }
              confirmation
            >
              <Button variant='outlined' color='primary'>
                Update
              </Button>
            </ConfirmDialog>
          )
        }}
      >
        <List
          columns={columns}
          {...this.props}
          searchable
          additional={PublicOnlySwitch}
          additionalProps={{
            publicOnly: this.props.filters.publicOnly,
            onChange: this.props.onChangeFilters('publicOnly'),
          }}
          emptyMessage={'No ecosystems matching the given criteria.'}
        />
      </DashboardPage>
    )
  }
}
